import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        //是否登录
        isLogin: sessionStorage.getItem("isLogin") === "true",
        //登录后的Token
        token: sessionStorage.getItem("token") || null,
        // token: "1234",
        //登录后的用户信息
        user: JSON.parse(sessionStorage.getItem("user")) || { name: '用户', email: 'admin@system.com' },
        // user: {
        //     username: "admin",
        //     name: "管理员"
        // },
        // 用户菜单权限
        menus: [],
        //左侧菜单栏展开状态
        collapsed: localStorage.getItem("collapsed") === "true",
        //应用名称
        projectName: "安心陪护",
        //API接口地址
        //全屏显示
        full: false,
        XTime: ''
    },
    mutations: {
        setLogin(state) {
            sessionStorage.setItem("isLogin", true);
            state.isLogin = true;
        },
        setXTime(state, val) {
            state.XTime = val;
        },
        setLoginOut(state) {
            // 仅清除管理端 session，避免误删家属端 familyToken
            const familyIsLogin = sessionStorage.getItem("familyIsLogin");
            const familyToken = sessionStorage.getItem("familyToken");
            const familyUser = sessionStorage.getItem("familyUser");
            sessionStorage.removeItem("isLogin");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user");
            if (familyIsLogin) sessionStorage.setItem("familyIsLogin", familyIsLogin);
            if (familyToken) sessionStorage.setItem("familyToken", familyToken);
            if (familyUser) sessionStorage.setItem("familyUser", familyUser);
            state.isLogin = false;
            state.token = null;
        },
        updateUser(state, val) {
            state.user = val
            sessionStorage.setItem("user", JSON.stringify(state.user));
        },
        setCollapsed(state) {
            state.collapsed = !state.collapsed;
            localStorage.setItem("collapsed", state.collapsed);
        },
        setRoutes(state, val) {
            state.routes = val;
        },
        setToken(state, val) {
            sessionStorage.setItem("token", val);
            state.token = val;
        },
        setFull(state) {
            state.full = !state.full;
        },
        setMenus(state, val) {
            state.menus = val;
        },
    },
    actions: {
        LogOut({ commit, state }) {
            return new Promise((resolve, reject) => {
                // 先调用后端logout接口
                if (state.token) {
                    axios({
                        url: "web/auth/logout",
                        method: "post",
                        headers: {
                            Authorization: state.token
                        }
                    }).then(() => {
                        console.log('后端logout接口调用成功');
                        commit('setLoginOut');
                        resolve();
                    }).catch((error) => {
                        console.log('后端logout接口调用失败:', error);
                        // 即使后端调用失败，也要清除本地状态
                        commit('setLoginOut');
                        resolve();
                    });
                } else {
                    // 没有token，直接清除本地状态
                    commit('setLoginOut');
                    resolve();
                }
            });
        }
    }
});